export const firebaseConfig = {
  apiKey: `AIzaSyDlM_ZKvHIk2JYdK_04GYKACLHkd1FLcV8`,
  authDomain: `swallow-spiegel-362612.firebaseapp.com`,
  projectId: `swallow-spiegel-362612`,
  storageBucket: `swallow-spiegel-362612.appspot.com`,
  messagingSenderId: `730536415645`,
  appId: `1:730536415645:web:b66e291225070dde5d9f74`,
  measurementId: `G-SJXF68SF0M`,
}